<script>
    import {onDestroy, onMount} from "svelte";
    import {dataStore} from "../stores/dataStore";
    import {popupStore} from "../stores/popupStore";
    import htmlParser from "../lib/htmlParser";

    // Static Data and Placeholders
    let language = window.location.href.split('/')[3] === 'en' ? 1 : 0;
    const popupId = "popupId"; // value doesn't matter
    let goBackText = language ? "Go Back" : "Powrót";
    // let info = "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem fuga aperiam soluta! Labore quasi illum aut suscipit expedita ducimus provident"

    export let dateKey;
    export let dateKeyValue;
    export let hallKey;

    export let showTable;

    let days = [
        {
            0: 'Niedziela',
            1: 'Poniedziałek',
            2: 'Wtorek',
            3: 'Środa',
            4: 'Czwartek',
            5: 'Piątek',
            6: 'Sobota'
        },
        {
            0: 'Sunday',
            1: 'Monday',
            2: 'Tuesday',
            3: 'Wednesday',
            4: 'Thursday',
            5: 'Friday',
            6: 'Saturday'
        }
    ];
    let months = [
        {
            0: 'stycznia',
            1: 'lutego',
            2: 'marca',
            3: 'kwietnia',
            4: 'maja',
            5: 'czerwca',
            6: 'lipca',
            7: 'sierpnia',
            8: 'września',
            9: 'października',
            10: 'listopada',
            11: 'grudnia'
        },
        {
            0: 'January',
            1: 'February',
            2: 'March',
            3: 'April',
            4: 'May',
            5: 'June',
            6: 'July',
            7: 'August',
            8: 'September',
            9: 'October',
            10: 'November',
            11: 'December'
        }
    ];

    // Dynamic Data
    // ----------------------------

    $: data = $dataStore;

    $: types = data.types;
    $: halls = data.halls;
    $: authors = data.authors;
    // $: console.log("Dane ze stora: ", data.sessions); 

    $: selectedSession = data.sessions[dateKey][dateKeyValue][hallKey][0];

    // Handling Title, some sessions doesn't have title/subtitle
    $: title = [selectedSession.title[0], selectedSession.title[1]];

    if (title && title === "") {
        title = [selectedSession.subtitle[0], selectedSession.subtitle[1]];
    }

    if (title) {
        title === title?.length > 0 ? title : ["Brak tytułu", "No Title"];
    }
    // ---------------------------------
    $: lectures = selectedSession.lectures.length !== 0 ? selectedSession.lectures : selectedSession.abstracts;
    $:{
        // console.log(selectedSession.abstracts)
    }
    $: clinicalCases = selectedSession.clinicalcases;
    // $: console.log(clinicalCases);
    $: short_info = selectedSession.short_info;
    $: info = selectedSession.info;
    $: isSessionContra = () => {

        if (lectures && !isObjectEmpty(lectures)) {
            let lecturesArray = Object.entries(lectures);
            for (let lecture of lecturesArray) {
                if (lecture[1].hasOwnProperty("authors_contra")) {
                    return true;
                }
            }

        }

        return false;
    }

    $: isSessionPro = () => {

        if (lectures && !isObjectEmpty(lectures)) {
            let lecturesArray = Object.entries(lectures);
            for (let lecture of lecturesArray) {
                if (lecture[1].hasOwnProperty("authors_pro")) {
                    return true;
                }
            }

        }

        return false;
    }

    $: isSpecialType = () => {
        if (types && !isObjectEmpty(types) && selectedSession.type && !isObjectEmpty(selectedSession)) {
            let selectedTypeLetter = types[selectedSession.type].letter;
            if (selectedTypeLetter == "K" || selectedTypeLetter == "U" || selectedTypeLetter == "P" || selectedTypeLetter == "X") {
                return true;
            }
        }
        return false;
    }

    $: containsPanel = () => {
        // return true;
        const panelText = "Panel dyskusyjny";
        if (!isObjectEmpty(selectedSession) && info) {
            if (typeof info == "string") {
                if (info.includes(panelText)) {
                    return true;
                }
            }
        }

        return false;
    }
    // ----------------------------


    // Popup state
    // ----------------------------
    let isPopupOpen;
    popupStore.subscribe(value => {
        isPopupOpen = value;
    });

    function closePopup() {
        const url = new URL(window.location);
        url.searchParams.delete('id');
        window.history.pushState({}, '', url);
        popupStore.set(false);
    }

    // ----------------------------

    // Helper functions
    // ----------------------------

    function getHoursAndMinutes(time) {
        const [hours, minutes] = time.split(':');
        return `${hours}:${minutes}`;
    }

    // gets name and returns first letter with a dot
    const shortName = (name) => {
        if (name && name[0]) {
            return `${name[0]}.`;
        }

        return "";
    }

    // gets name and lastname and returns first letter of the name with a dot and lastname
    const shortFullName = (fullname) => {
        let fullnameArray = fullname.split(" ");
        fullnameArray[0] = shortName(fullnameArray[0]);
        return fullnameArray.join(" ");
    }

    function isObjectEmpty(obj) {
        for (let x in obj) {
            if (obj.hasOwnProperty(x)) return false;
        }
        return true;
    }

    function formatDate(string, option) {
        // 1 - get day 1-31
        // 2 - get weekday mon-sun
        // 3 - get month jan-dec
        let date = new Date(string);
        let answer;
        switch (option) {
            case 1:
                answer = date.getDate();
                break;
            case 2:
                answer = days[language][date.getDay()];
                break;
            case 3:
                answer = months[language][date.getMonth()];
                break;
        }
        return answer;
    }

    function returnSafeData(data) {
        return data ? data : ""
    }

    // ----------------------------
    // Listeners (Double Scroll Fix, outside click closes Popup)  

    const handleScrollBehavior = () => {
        if (isPopupOpen) {
            document.body.style.overflowY = "hidden";
        } else {
            document.body.style.overflowY = "auto";
        }
    }

    onMount(() => {
        handleScrollBehavior();
        enableOutsideClick();
        console.log(htmlParser(info))
    });

    onDestroy(() => {
        handleScrollBehavior();
        disableOutsideClick();
    });

    let listenerFunc;
    let ignoreFirstClick = true;
    // Function to handle adding the event listener
    const enableOutsideClick = () => {
        const popupNode = document.getElementById(popupId);
        listenerFunc = (e) => {
            if (ignoreFirstClick) {
                ignoreFirstClick = false;
                return;
            }
            if (popupNode && !popupNode.contains(e.target)) {
                // console.log("Outside click registered");
                closePopup();
            }
        }
        document.addEventListener("click", listenerFunc);


    };

    // Function to handle removing the event listener
    const disableOutsideClick = () => {
        document.removeEventListener("click", listenerFunc);
    };

    // ----------------------------
    // Parser

    $: parsedHTML = htmlParser(info);

    // ----------------------------


</script>

<div id="default-modal" tabindex="-1" aria-hidden="false"
     class="sm:w-full overflow-y-hidden overflow-x-hidden fixed inset-x-0 flex justify-center items-center w-full inset-0 popup-modal"
     style="height: 100vh; z-index:100000; top:0; max-width: 100vw;">

    {#if data && !isObjectEmpty(data)}
        <div class="popup absolute overflow-y-auto top-20 h-[calc(100vh-105px)] shadow rounded-sm" id={popupId}
             >
            <div class="relative bg-white rounded-sm shadow">
                <!-- Close Button -->
                <div class="flex items-start justify-between py-4 px-4">
                    <button type="button" on:click={closePopup}
                            class="flex items-center justify-center px-2 py-1 gap-2 rounded-md transition bg-gray-400 opacity-80 hover:opacity-100 hover:shadow-inner active:opacity-100 active:ring-2 ring-gray-500"
                    >
                        <svg fill="#ffffff" width="30px" height="30px" viewBox="0 0 56 56"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M 27.9999 51.9063 C 41.0546 51.9063 51.9063 41.0781 51.9063 28 C 51.9063 14.9453 41.0312 4.0937 27.9765 4.0937 C 14.8983 4.0937 4.0937 14.9453 4.0937 28 C 4.0937 41.0781 14.9218 51.9063 27.9999 51.9063 Z M 27.9999 47.9219 C 16.9374 47.9219 8.1014 39.0625 8.1014 28 C 8.1014 16.9609 16.9140 8.0781 27.9765 8.0781 C 39.0155 8.0781 47.8983 16.9609 47.9219 28 C 47.9454 39.0625 39.0390 47.9219 27.9999 47.9219 Z M 34.0234 37.6094 C 35.1483 37.6094 35.9687 36.7890 35.9687 35.7344 C 35.9687 34.8437 35.5936 34.3047 34.6093 33.8359 L 22.7265 28 L 22.7265 27.8594 L 34.6093 21.9063 C 35.5702 21.4141 35.9687 20.8516 35.9687 20.0078 C 35.9687 18.9531 35.1718 18.1563 34.0702 18.1563 C 33.5546 18.1563 33.2733 18.2266 32.8983 18.4141 L 18.9296 25.9609 C 17.9921 26.4531 17.5468 27.1328 17.5468 28.0234 C 17.5468 28.9844 17.9452 29.5703 18.9296 30.0859 L 32.8983 37.3281 C 33.2499 37.5156 33.5546 37.6094 34.0234 37.6094 Z"/>
                        </svg>

                        <span class="pr-1 text-white font-semibold text-md">
                            {goBackText}
                        </span>
                    </button>
                </div>

                <!-- Content -->
                <div class="flex flex-col items-start justify-start gap-2 px-8 w-full">

                    <!-- Title -->
                    <div class="py-4 w-full">
                        <h1 class="font-semibold text-xl">{title[0]}</h1>
                        <div class="font-semibold text-sm italic">{title[1]}</div>
                    </div>

                    <!-- Info -->
                    <div class="py-4 w-full" style="display: {showTable.length === 0 ? 'none' : 'block'};">
                        <div class="border-md flex flex-col gap-1 rounded-sm text-box" style="background-color: rgb(202, 181, 94)">
                            <div class="flex gap-1 p-2 w-full whitespace-nowrap">
                                <div class="icon">
                                    <img src="resources/nowy_program_glowny/icons8-bookmark-50.png" alt="Bookmark">
                                </div>
                                <div class="font-semibold">Typ sesji:</div>
                                <div>{types[selectedSession.type].name[0]}</div>
                            </div>
                            <div
                                    class="h-[2px] w-full bg-white"
                            ></div>

                            <div class="flex gap-1 p-2 whitespace-nowrap">
                                <div class="icon">
                                    <img src="resources/nowy_program_glowny/icons8-calendar-48.png" alt="Date">
                                </div>
                                <div class="font-semibold">Data:</div>
                                <div>{formatDate(selectedSession.date, 1) + " " + formatDate(selectedSession.date, 3)}</div>
                            </div>
                            <div
                                    class="h-[2px] w-full bg-white"
                            ></div>

                            <div class="flex gap-1 p-2 whitespace-nowrap">
                                <div class="icon">
                                    <img src="resources/nowy_program_glowny/icons8-bookmark-50.png" alt="Bookmark">
                                </div>
                                <div class="font-semibold">Start sesji:</div>
                                <div>{getHoursAndMinutes(selectedSession.time_start)}</div>
                            </div>
                            <div
                                    class="h-[2px] w-full bg-white"
                            ></div>

                            <div class="flex gap-1 p-2 whitespace-nowrap">
                                <div class="icon">
                                    <img src="resources/nowy_program_glowny/icons8-clock-48.png" alt="Clock">
                                </div>
                                <div class="font-semibold">Koniec sesji:</div>
                                <div>{getHoursAndMinutes(selectedSession.time_end)}</div>
                            </div>
                            <div
                                    class="h-[2px] w-full bg-white"
                            ></div>

                            <div class="flex gap-1 p-2 whitespace-nowrap">
                                <div class="icon">
                                    <img src="resources/nowy_program_glowny/icons8-telegram-32.png" alt="telegram">
                                </div>
                                <div class="font-semibold">Sala:</div>
                                <div>{halls[selectedSession.hall].name[0]}</div>
                            </div>

                        </div>
                    </div>

                    <!-- Authors -->
                    <div class="py-4 w-full">
                        <div class="flex flex-col gap-2">
                            <!-- Parsing from info (may contain bugs) -->
                            <!-- {#if !isObjectEmpty(parsedHTML) && parsedHTML.moreInfo}
                                <div>
                                    <div class="font-semibold text-xl">
                                        Więcej o sesji
                                    </div>
                                    <div>
                                        {returnSafeData(parsedHTML.moreInfo)}
                                    </div>
                                </div>
                            {/if} -->

                            {#if !isObjectEmpty(selectedSession) && selectedSession.subtitle && selectedSession.subtitle.length > 0 && selectedSession.subtitle[0].length > 0}
                                <div>
                                    <div class="font-semibold text-xl">
                                        Więcej o sesji
                                    </div>
                                    <div>
                                        {returnSafeData(selectedSession.subtitle[0])} <br>
                                        {returnSafeData(selectedSession.subtitle[1])}
                                    </div>
                                </div>
                            {/if}

                            {#if !isObjectEmpty(parsedHTML) && parsedHTML.chairpersons && !isObjectEmpty(parsedHTML.chairpersons) && parsedHTML.chairpersons.length > 0}
                                <div>
                                    <div class="font-semibold text-xl">
                                        Przewodniczący
                                    </div>
                                    <div class="flex gap-1 flex-wrap">
                                        {#each parsedHTML.chairpersons as chairperson, index}
                                            <div style="">{shortFullName(chairperson.name)} {chairperson.city === "" ? "" : `(${chairperson.city})`}{index + 1 === parsedHTML.chairpersons.length ? '' : ', '}</div>
                                        {/each}
                                    </div>
                                </div>
                            {/if}

                            {#if !isObjectEmpty(parsedHTML) && parsedHTML.jury && !isObjectEmpty(parsedHTML.jury) && parsedHTML.jury.length > 0}
                                <div>
                                    <div class="font-semibold text-xl">
                                        Jury
                                    </div>
                                    <div class="flex gap-1 flex-wrap">
                                        {#each parsedHTML.jury as person, index}
                                            <div style="">{shortFullName(person.name)} {person.city === "" ? "" : `(${person.city})`}{index + 1 === parsedHTML.jury.length ? '' : ', '}</div>
                                        {/each}
                                    </div>
                                </div>
                            {/if}

                            {#if isSessionContra()}
                                <div></div>
                            {/if}
                            <!-- Moderators -->
                            {#if isSpecialType()}
                                <div>
                                    {#if !isObjectEmpty(selectedSession) && selectedSession.authors.moderator && selectedSession.authors.moderator.length > 0}
                                        <div class="font-semibold text-xl">
                                            Moderatorzy
                                        </div>
                                    {/if}

                                    <div class="flex gap-1 flex-wrap">
                                        {#if !isObjectEmpty(selectedSession) && selectedSession.authors.moderator}
                                            {#each selectedSession.authors.moderator as authorId,index}
                                                {#if !isObjectEmpty(authors) && !isObjectEmpty(authors[authorId])}
                                                    {shortName(returnSafeData(authors[authorId].firstname))} {returnSafeData(authors[authorId].lastname)} {authors[authorId].city ? `(${authors[authorId].city})` : ""}{index + 1 === selectedSession.authors.moderator.length ? '' : ', '}
                                                {/if}
                                            {/each}
                                        {/if}
                                    </div>
                                </div>
                            {/if}

                            <!-- is not contra and doesn't have moderators    -->
                            {#if !isObjectEmpty(parsedHTML) && parsedHTML.others && !isObjectEmpty(parsedHTML.others) && parsedHTML.others.length > 0 }
                                {#if containsPanel()}
                                    <div>
                                        <div class="font-semibold text-xl">
                                            Panel Dyskusyjny
                                        </div>

                                        <div class="flex gap-1 flex-wrap">
                                            {#each parsedHTML.others as person, index}
                                                <div>{shortFullName(person.name)}{person.city === "" ? "" : ` (${person.city})`}{index + 1 === parsedHTML.others.length ? '' : ', '}</div>
                                            {/each}
                                        </div>
                                    </div>
                                {/if}

                            {/if}
                        </div>
                    </div>

                    <!-- Lecturers -->
                    <div class="py-4 w-full">
                        <div class="flex flex-col gap-2">
                            {#if !isObjectEmpty(lectures)}
                                {#each Object.keys(lectures) as lectureKey}
                                    <div class="p-2 pl-6 border-2 border-gray-300 rounded-md">
                                        <div class="font-semibold text-lg">
                                            {lectures[lectureKey].title[0] ? lectures[lectureKey].title[0] : ""}
                                        </div>
                                        <div class="italic">
                                            {lectures[lectureKey].title[1] ? `(${lectures[lectureKey].title[1]})` : ""}
                                        </div>

                                        {#if !isObjectEmpty(authors)}
                                            <!-- authors -->
                                            {#if lectures[lectureKey] && lectures[lectureKey].hasOwnProperty("authors")}
                                                {#if lectures[lectureKey].authors.length > 0}
                                                    {#each lectures[lectureKey].authors as author}
                                                        {#if author && !isObjectEmpty(authors[author])}
                                                            <div class="one-line">
                                                                <div class="icon">
                                                                    <img src="resources/nowy_program_glowny/icons8-avatar-64.png"
                                                                         alt="">
                                                                </div>
                                                                {shortName(authors[author].firstname)} {authors[author].lastname} {authors[author].city ? `(${authors[author].city})` : "" }
                                                            </div>
                                                        {/if}
                                                    {/each}

                                                {/if}

                                                <!-- Pro and Contra -->
                                            {:else if lectures[lectureKey] && (isSessionContra() || isSessionPro())}
                                                {#if isSessionPro()}
                                                    <div class="one-line">
                                                        {#if lectures[lectureKey].authors_pro && lectures[lectureKey].authors_pro.length > 0}
                                                            <div>Pro:</div>
                                                            {#each lectures[lectureKey].authors_pro as author_pro}
                                                                <div>
                                                                    {shortName(authors[author_pro].firstname)} {authors[author_pro].lastname} {authors[author_pro].city ? `(${authors[author_pro].city})` : ""}
                                                                </div>
                                                            {/each}
                                                        {/if}
                                                    </div>
                                                {/if}

                                                {#if isSessionContra()}
                                                    <div class="one-line">
                                                        {#if lectures[lectureKey].authors_contra && lectures[lectureKey].authors_contra.length > 0}
                                                            <div>Contra:</div>
                                                            {#each lectures[lectureKey].authors_contra as author_contra}
                                                                <div>
                                                                    {shortName(authors[author_contra].firstname)} {authors[author_contra].lastname} {authors[author_contra].city ? `(${authors[author_contra].city})` : ""}
                                                                </div>
                                                            {/each}
                                                        {/if}
                                                    </div>
                                                {/if}
                                            {/if}
                                        {/if}

                                    </div>
                                {/each}

                                <!-- Clinical Cases -->
                            {:else if clinicalCases && !isObjectEmpty(clinicalCases)}
                                {#each Object.keys(clinicalCases) as caseKey}
                                    <div class="p-2 pl-6 border-2 border-gray-300 rounded-md">
                                        <div class="font-semibold text-lg">
                                            {returnSafeData(clinicalCases[caseKey].title[0])}
                                        </div>
                                        <div class="italic">
                                            {clinicalCases[caseKey].title[1] ? `(${clinicalCases[caseKey].title[1]})` : ""}
                                        </div>

                                        {#if authors && !isObjectEmpty(authors)}
                                            {#if clinicalCases[caseKey].authors && clinicalCases[caseKey].authors.length > 0}
                                                {#each clinicalCases[caseKey].authors as authorId}
                                                    <div class="author">

                                                        <div class="icon">
                                                            <img src="resources/nowy_program_glowny/icons8-avatar-64.png"
                                                                 alt="Avatar">
                                                        </div>

                                                        {#if authors[authorId] && !isObjectEmpty(authors[authorId])}
                                                            {shortName(returnSafeData(authors[authorId].firstname))}
                                                            {returnSafeData(authors[authorId].lastname)}
                                                            {authors[authorId].city ? `(${authors[authorId].city})` : ""}
                                                        {/if}
                                                    </div>
                                                {/each}
                                            {/if}
                                        {/if}

                                    </div>
                                {/each}
                            {:else}
                            {/if}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    {/if}

</div>

<style>
    .author {
        display: flex;
    }

    .icon {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .popup {
        height: 90vh;
    }

    .icon > img {
        /* 24px */
        width: 1.2rem;
        height: 1.2rem;
    }

    .one-line {
        display: flex;
        gap: 3px;
    }

    #default-modal {
        /* padding: 0; */
        margin: 0;
    }

    #popupId {
        width: 100%; /* Default width */
        max-width: 80%;
    }

    @media (min-width: 640px) {
        /* sm: small screens */
        #popupId {
            width: 80%; /* 4/5 */
            max-width: none;
        }

    }

    @media (min-width: 768px) {
        /* md: medium screens */
        #popupId {
            width: 60%; /* 3/5 */
        }
    }

    @media (max-width: 768px) {
        .popup {
            height: 80vh;
            top: 5%;
        }
    }

    @media (min-width: 1024px) {
        /* lg: large screens */
        #popupId {
            width: 60%; /* 3/5 */
        }
    }

    @media (min-width: 1280px) {
        /* xl: extra-large screens */
        #popupId {
            width: 60%; /* 3/10 */
        }
    }

    @media (min-width: 1536px) {
        /* 2xl: 2X-large screens */
        #popupId {
            width: 60%; /* 1/6 */
        }
    }

    @media only screen and (max-width: 600px) {
        .popup-modal {
            margin-left: -2rem;
        }

        .text-box {
            font-size: 13px;
        }
    }

</style>